export default __webpack_public_path__ + "static/media/pencil-clear-summer.9a316f21.png";